import { createContext } from 'react';

// FIN-869: types/context object shared by FeedbackContext.tsx and useFeedbackContext.ts — kept
// out of both so neither mixes a component export with a non-component export
// (react-refresh/only-export-components).

export type FeedbackContextRecord = Record<string, unknown>;

export interface FeedbackContextApi {
  getContext: () => FeedbackContextRecord;
}

export interface FeedbackContextRegistry extends FeedbackContextApi {
  register: (id: string, value: FeedbackContextRecord) => void;
  unregister: (id: string) => void;
}

export const ReactFeedbackContext = createContext<FeedbackContextRegistry | null>(null);
